import { type UserProfile } from '@/shared/api/user/types';
import { MessageType } from '@/shared/hooks/use-ws/types';
import { AnalyticsService } from '@/shared/service/analytics/analytics-service';

export const gameAnalyticEventNewPaymentHandler = (
  value: any,
  sessionId: string,
  profile: UserProfile | undefined
) => {
  const event = {
    type: 'new_payment',
    user_properties: {
      ...value?.user_properties,
      session_id: sessionId,
      telegramId: profile?.telegramId,
    },
    event_properties: {
      name: 'new_payment',
      date: Date.now(),
      amount: value?.amount,
      currency: value?.currency,
    },
    created: Date.now(),
  };

  AnalyticsService.send(event, MessageType.GAME_ANALYTICS);
};
